/**
 * FTP / SFTP: a dual-pane file browser (modern FileZilla) over the Rust ftp_*
 * commands (plans/25_07_2026/vault-suite/CONTRACTS.md §2). Like Vault it is
 * HOST-RENDERED (FtpSidebar.js + FtpView.js) — connections are NOT stored by
 * this extension: they are the vault's `sftp`-typed items, created/edited via
 * VaultItemModal, so credentials stay inside the encrypted vault. The guest
 * entry.js is a no-op kept only to satisfy the registration contract.
 *
 * The icon-rail slot sits right after Vault; clicking it opens the ftp panel
 * (App.js `activeTab === 'ftp.panel'` branch → FtpSidebar as the sidebar,
 * FtpView as the content — chat-style, no tab strip).
 */
export const ftpManifest = {
  schemaVersion: 1,
  id: 'com.apiboo.ftp',
  name: 'FTP',
  version: '0.1.0',
  publisher: 'apiboo',
  entry: 'dist/main.js',
  icon: 'server',
  engines: { apibooSdk: '^1.0.0' },
  // HOST-RENDERED, not sandboxed: the panel above is a first-party React
  // component calling Tauri directly, so `permissions: []` means "declares no
  // GUEST capabilities", not "has no access". Settings reads this flag to say
  // that plainly instead of showing an empty permission list that implies a
  // control the user does not have — see EXT-05.
  hostRendered: true,
  permissions: [],
  contributes: {
    activityBar: [
      {
        id: 'ftp.activity',
        title: 'FTP / SFTP',
        icon: 'server',
        order: { after: 'vault.activity' },
      },
    ],
    panels: [{ id: 'ftp.panel', activityBarId: 'ftp.activity', title: 'FTP / SFTP' }],
    settings: [],
  },
};
